import {
  IntlListFormatType,
  LANGUAGE_VARIANT_SEPARATOR,
} from '../constants/common'
import { DATE_LOCALES, DEFAULT_DATE_LOCALE } from '../constants/date'

/**
 * @param {string} language
 *
 * @returns {import('date-fns').Locale}
 */
export function getDateLocale(language) {
  return DATE_LOCALES.get(language) ?? DEFAULT_DATE_LOCALE
}

/**
 * A BCP 47 locale for the `Intl` APIs: the audience suffix of a UI language
 * (`de_in`) is not a valid subtag, so only the base language is kept.
 *
 * @param {string} language
 *
 * @returns {string}
 */
export function getIntlLocale(language) {
  return language.split(LANGUAGE_VARIANT_SEPARATOR)[0]
}

/**
 * Joins items into one phrase in the UI language: "a, b und c" / "a, b, and c".
 *
 * @param {string[]} items
 * @param {string} language
 * @param {string} [type=IntlListFormatType.conjunction] "und" / "oder" / a plain list.
 *
 * @returns {string}
 */
export function formatIntlList(
  items,
  language,
  type = IntlListFormatType.conjunction
) {
  return new Intl.ListFormat(getIntlLocale(language), { type }).format(items)
}
